// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__AMIAZ","left":"Virtual_left__gijmX","wrapper":"Virtual_wrapper__rUA5m"};